import { BaseActionDefinition } from './base-action-definition'
import { CustomActionDefinition } from './custom-action-definition'
export class BaseActionBuilder {
  // prettier-ignore
  public static buildAction(action: BaseActionDefinition): BaseActionDefinition {
    let result: BaseActionDefinition | null = null
    if (action.actionType == 'CustomAction')
      result = new CustomActionDefinition(action as CustomActionDefinition)
    else
      result = action
    return result as BaseActionDefinition
  }
}
